module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-243.76d3367c.jpg";